import React from 'react';
import EditorialBlock from '../oracle/EditorialBlock';
import useDocumentTitle from '../../hooks/useDocumentTitle';

// Shared shell for the public content pages (About, FAQ, Contact, routed
// legal): a centered editorial column with an eyebrow + headline header.
// Navigation lives solely in the fixed PublicNav bar mounted by PublicShell;
// pb-[60px] reserves its height so nothing hides under it. Sets
// document.title per page and restores the brand default on unmount.
//
//   ┌──────────────────────────────────┐
//   │        eyebrow (aurum caps)      │
//   │        headline (serif M)        │
//   │        {children}                │
//   ├──────────────────────────────────┤
//   │ PublicNav (fixed, bottom)        │
//   └──────────────────────────────────┘
const PublicPageLayout = ({ title, eyebrow, headline, children }) => {
  useDocumentTitle(title);

  return (
    <div className="min-h-screen bg-obsidian text-bone flex flex-col pb-[calc(60px+env(safe-area-inset-bottom))]">
      <main className="mx-auto w-full max-w-[820px] flex-1 px-6 py-16 lg:py-24">
        {eyebrow && (
          <p className="m-0 mb-4 font-display uppercase text-[11px] tracking-[0.2em] text-aurum">
            {eyebrow}
          </p>
        )}
        {/* as="h1" — these are standalone crawlable pages; the headline is
            the document's single h1 for SEO and screen-reader outline. */}
        <EditorialBlock headline={headline} size="M" as="h1" />
        <div className="mt-12">{children}</div>
      </main>
    </div>
  );
};

export default PublicPageLayout;
